import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'
import Checkout from '../components/Checkout'
import config from '../../data/siteConfig'

class BuyNowPage extends Component {
  renderCheckout = () => {
    const { data: { loading, error, products } } = this.props;

    return <Checkout error={error} loading={loading} vouchers={products} />
  }
  render() {
    return (
      <span>
        <Helmet
          title={`${config.siteName} | Bookings | ${config.siteTitleAlt}`}
          meta={[
            {
              name: 'description',
              content: `How to purchase your 4x4 driving experience. Book your eVoucher online or call ${config.sitePhone} today. Book for stag & Hen parties, corporate packages, 1 on 1 training and birthday parties. We cater for all ages and experiences.`
            }
          ]}
        />
        <div className="buy-now banner">
          <div className="banner-info top-off-center text-center">
            <h2 className="uppercase">Book your 4x4 experience day</h2>
          </div>
        </div>
        <main>
          <section className="row">
            <div className="small-12 medium-10 columns">
              <div className="content-header">
                <h1 className="uppercase">Bookings</h1>
              </div>
            </div>
          </section>
          <section className="row">
            <div className="large-9 columns">
              <div className="content-body">
                <h3 className="subheader">Purchase your 4x4 driving experience online</h3>
                <p>Our 4x4 eVouchers will arrive in your inbox ASAP after you order, they are ideal birthday presents and Christmas gifts. Valid for 6 months, every experience voucher we've sold has been redeemed.</p>
                {this.renderCheckout()}
              </div>
            </div>
            <div className="large-3 columns">
              <div className="content-body">
                <div className="callout text-center">
                  <h4>Group booking?</h4>
                  <p>If you would like to book for a group, for example a stag do, hen party, corporate day or 1-on-1 professional training please <strong>call us on {config.sitePhone}</strong> and we can tailor the day to your needs.</p>
                  <p>Alternatively drop us a message using our <Link to="/contact">contact form</Link></p>
                </div>
              </div>
            </div>
          </section>
        </main>
      </span>
    );
  }
}

// We use the gql tag to parse our query string into a query document
const CurrentExperiences = gql`
  query CurrentExperiences {
    products {
      id
      name
      description
      price_pence
    }
  }
`;

const BuyNowPageWithData = graphql(CurrentExperiences)(BuyNowPage);

// BuyNowPage.propTypes = {

// };

export default BuyNowPageWithData;



// WEBPACK FOOTER //
// ./src/pages/bookings.js